import { useMutation, useQueryClient } from '@tanstack/react-query';
import { formatCount } from '@/utils/number';
import { stagePcmpMisBatch } from '../api/pcmpMis.api';
import type { PcmpMisStagePayload, PcmpMisStageResult } from '../types/pcmpMis.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function useStagePcmpMisBatch(onSuccess: (result: PcmpMisStageResult) => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpMisStagePayload) => stagePcmpMisBatch(payload),
    ...pcmpActionCallbacks<PcmpMisStageResult>(
      queryClient,
      (result) =>
        `Batch #${result.batchNo} staged with ${formatCount(result.staged.length, 'proposal')}`,
      onSuccess,
    ),
  });
}
